<section class="container-fluid clearfix pb-2">
  <div class="row">
    <div class="col-12 text-center mt-5 mb-5" *ngIf="loading">
      <h2>Cargando información, por favor espere...</h2>
    </div>
    <div class="col-12 p-0" *ngIf="data.filters">
      <app-mapa-captacion-agua
        [sedes]="data"
        [catalogo]="popups"
        ></app-mapa-captacion-agua>
    </div>
  </div>
</section>
